/**
 * External Dependencies
 */
import $ from 'jquery'
import 'slick-carousel'
import 'mmenu-js'
import Plyr from 'plyr'
import AOS from 'aos'
import moderStories from './modern-stories-content.js'

moderStories()

$(() => {
  const header = document.getElementById('header')
  const filterBar = document.getElementById('filter-bar')
  const searchBar = document.getElementById('search-bar')
  const searchBarClose = document.getElementById('search-bar--close')

  // --- header scrolling down on scroll / swipe up
  const sensibleScrollArea = header.offsetHeight * 2
  let lastScroll = 0

  window.addEventListener('scroll', function (e) {
    const windowOffsetY =
      window.pageYOffset || document.documentElement.scrollTop
    if (windowOffsetY > lastScroll && windowOffsetY > sensibleScrollArea) {
      header.classList.add('scrolled')
      if (filterBar) {
        filterBar.classList.add('scrolled')
      }
    } else {
      header.classList.remove('scrolled')
      if (filterBar) {
        filterBar.classList.remove('scrolled')
      }
    }
    lastScroll = windowOffsetY <= 0 ? 0 : windowOffsetY
    e.preventDefault()
  })

  searchBarClose.addEventListener('click', function () {
    searchBar.classList.remove('open')
  })

  // Responsive menu
  // --- toggle menu visibility through hambuger menu

  // Carousels
  const carouselGallery = document.querySelectorAll('.carousel__gallery')

  carouselGallery.forEach((gallery) => {
    let additionalOptions = gallery.getAttribute('data-options')
    try {
      additionalOptions = JSON.parse(additionalOptions)
    } catch (error) {
      additionalOptions = {}
    }

    const prevArrows = gallery.querySelectorAll('.nav-prev')
    const nextArrows = gallery.querySelectorAll('.nav-next')

    $(gallery).slick({
      dots: true,
      arrows: false,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 768,
          setting: {
            adaptiveHeight: true
          }
        }
      ],
      ...additionalOptions
    })

    prevArrows.forEach((e) => {
      if (e) {
        e.addEventListener('click', () => {
          window.jQuery(gallery).slick('slickPrev')
        })
      }
    })
    nextArrows.forEach((e) => {
      if (e) {
        e.addEventListener('click', () => {
          window.jQuery(gallery).slick('slickNext')
        })
      }
    })

    // set first slide dots
    setDotsPosition('.slick-gallery-wrapper')
  })

  $('.carousel__gallery').on(
    'afterChange',
    function (event, slick, currentSlide, nextSlide) {
      setDotsPosition('.slick-gallery-wrapper')
    }
  )

  // Layouts
  // --- layout: testo_singolo - toggling hidden text with the read more
  const paragraph = document.querySelectorAll('.paragraph')

  paragraph.forEach((el) => {
    const readMore = el.querySelector('.paragraph__read-more')

    if (readMore) {
      readMore.addEventListener('click', function () {
        this.toggleClass('open')
      })
    }
  })

  // Horizontal scroll
  const postList = document.querySelector('.post__list')

  if (postList) {
    let isDown = false
    let startX
    let scrollLeft

    postList.addEventListener('mousedown', (e) => {
      isDown = true
      postList.classList.add('active')
      startX = e.pageX - postList.offsetLeft
      scrollLeft = postList.scrollLeft
    })
    postList.addEventListener('mouseleave', () => {
      isDown = false
      postList.classList.remove('active')
    })
    postList.addEventListener('mouseup', () => {
      isDown = false
      postList.classList.remove('active')
    })
    postList.addEventListener('mousemove', (e) => {
      if (!isDown) return
      e.preventDefault()
      const x = e.pageX - postList.offsetLeft
      const walk = (x - startX) * 3 // scroll-fast
      postList.scrollLeft = scrollLeft - walk
    })
  }

  // Mobile menu
  const menu = new Mmenu('#mobile-menu__content', {
    offCanvas: false,
    navbar: {
      title: false
    }
  })

  const apiMenu = menu.API

  apiMenu.bind('openPanel:finish', updateMMenuPanel)

  const mobileMenuBtn = document.getElementById('mobile-menu-btn')
  const mobileMenuWrapper = document.getElementById('mobile-menu')
  const mobileMenuBtnIconOpen = document.querySelector(
    '[data-mobile-menu-btn-icon="open"]'
  )
  const mobileMenuBtnIconClose = document.querySelector(
    '[data-mobile-menu-btn-icon="close"]'
  )

  mobileMenuBtn.addEventListener('click', function () {
    mobileMenuWrapper.classList.toggle('open')
    mobileMenuBtnIconOpen.classList.toggle('hidden')
    mobileMenuBtnIconClose.classList.toggle('hidden')
  })

  const mobileMenu = document.querySelector('#mobile-menu')

  // Products filters
  const dataFiltersMultiple = document.querySelector(
    '[data-filters-multiple="1"]'
  )

  if (dataFiltersMultiple) {
    const filtersOptionsEl = document.querySelectorAll(
      '.filters .filters__options .filters__option'
    )
    const filtersSelectedEl = document.querySelector(
      '.filters .filters__selected'
    )

    filtersOptionsEl.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.preventDefault()
        const filterName = this.textContent.trim()
        const filterSlug = this.getAttribute('data-filter')

        const params = new URLSearchParams(window.location.search)
        if (params.has('filters')) {
          const filtersParm = params
            .get('filters')
            .split(',')
            .filter(function (el) {
              return el
            })
          const filtersSelected = filtersSelectedEl.textContent
            .trim()
            .split('/')
            .filter(function (el) {
              return el.trim()
            })
          if (filtersParm.indexOf(filterSlug) === -1) {
            filtersParm.push(filterSlug)
            filtersSelected.push(filterName)
          } else {
            filtersParm.splice(filtersParm.indexOf(filterSlug), 1)
            filtersSelected.splice(filtersSelected.indexOf(filterName), 1)
          }

          if (filtersParm.length === 0) {
            // params.delete('filters')
            // document.location.search = params
            document.location.href = document.location.href.split('?')[0]
            // eslint-disable-next-line no-undef
            filtersSelectedEl.textContent = grootTranslations.all
          } else {
            params.set('filters', filtersParm.join(','))
            document.location.search = params
            filtersSelectedEl.textContent = filtersSelected.join(' / ')
          }
        } else {
          params.append('filters', filterSlug)
          document.location.search = params
          filtersSelectedEl.textContent = filterName
        }
      })
    })
  }

  // Handlers
  initUIHandlers()
  initMobileFilterButton()
  initDarkModeHandlers()
  initLoadMore()
  closeWhenBlur(searchBar)
  initAccordion()
  initFinishes()
  initFoldableSections()
  initVideoGallery()
  initPlyr()
  initTabs()
  initYearsSlideshow()
  initFinishModal()
  initSidebox()
  initForm()
  initAOS()
})

function initUIHandlers () {
  initDOMLoad()
  initScroll()
  initSearchBarHandlers()
}

function applyScrollUpdates () {
  const targetElement = document.querySelector('[data-sticky]')
  if (!targetElement) return

  if (
    window.scrollY > 0 &&
    !targetElement.classList.contains('md:shadow-light')
  ) {
    targetElement.classList.add('md:shadow-light')
  }
  if (
    window.scrollY === 0 &&
    targetElement.classList.contains('md:shadow-light')
  ) {
    targetElement.classList.remove('md:shadow-light')
  }
}

function initDOMLoad () {
  window.addEventListener('load', () => {
    applyScrollUpdates()
  })
}

function initScroll () {
  window.addEventListener('scroll', applyScrollUpdates)
}

function initMobileFilterButton () {
  const mobileFilterButton = document.querySelector(
    '[data-mobile-filter-button]'
  )
  if (!mobileFilterButton) return

  const mobileFilterBody = mobileFilterButton.parentNode.querySelector(
    '[data-mobile-filter-body]'
  )

  const mobileFilterIcon = mobileFilterButton.querySelector(
    '[data-mobile-filter-icon]'
  )
  const mobileFilterIconVLine = mobileFilterIcon.querySelector('#v-line')

  mobileFilterButton.addEventListener('click', function () {
    mobileFilterBody.classList.toggle('hidden')
    mobileFilterIconVLine.classList.toggle('hidden')
  })
}

function initSearchBarHandlers () {
  const searchBarButtons = document.querySelectorAll('[data-search-bar-button')
  const searchBar = document.getElementById('search-bar')
  const searchBarInput = searchBar.querySelector('input')

  for (const searchBarButton of searchBarButtons) {
    searchBarButton.addEventListener('click', function () {
      searchBar.classList.toggle('open')

      searchBarInput.focus()
      searchBarInput.value = ''
    })
  }
}

// initializee the dark mode JS logic for  load and toggle it
function initDarkModeHandlers () {
  // Load the dark mode selected
  const theme = window.localStorage.getItem('theme') || 'light'
  setTheme(theme)

  // The manual toggling of the dark mode
  const toggler = document.querySelector('[data-dark-mode-button]')
  if (!toggler) return

  toggler.addEventListener('click', function () {
    document.documentElement.classList.toggle('dark')
    if (document.documentElement.classList.contains('dark')) {
      setTheme('dark')
    } else {
      setTheme('light')
    }
  })
}

function closeWhenBlur (element) {
  if (window.innerWidth < 1024) return
  document.addEventListener('click', function (event) {
    if (
      event.target.parentNode.id === 'search-bar--open' ||
      event.target.parentNode.getAttribute('data-search-bar-button')
    ) {
      return
    }

    const isClickInside = element.contains(event.target)
    if (!isClickInside) {
      element.classList.remove('open')
    }
  })
}

function setTheme (theme) {
  const isTargetPage = document.querySelector(
    '.progetto-sostenibilita-ambientale'
  )
  if (!isTargetPage) return

  const labelTheme = document.querySelector('[data-dark-mode-theme]')

  const capitalizedTheme = theme[0].toUpperCase()
  const lowerizedTheme = theme.substr(1)
  const themeLabel = capitalizedTheme + lowerizedTheme

  document.documentElement.classList.remove(
    theme === 'dark' ? 'light' : 'dark'
  )
  document.documentElement.classList.add(theme)
  window.localStorage.setItem('theme', theme)

  if (labelTheme) {
    labelTheme.innerHTML = themeLabel
  }
}

function updateMMenuPanel (panel) {
  const panelID = panel.id

  const panel0 = document.querySelector(
    'div[data-mobile-menu-footer-level="0"]'
  )
  const panelN = document.querySelector(
    'div[data-mobile-menu-footer-level="n"]'
  )

  if (panelID.match(/mm-[0-9]+/)) {
    panel0.classList.add('h-0')
    panelN.classList.remove('h-0')
  } else {
    panel0.classList.remove('h-0')
    panelN.classList.add('h-0')
    return
  }

  const linkTrigger = document.querySelector(
    '.mm-panels a[href="#' + panelID + '"]'
  )
  if (!linkTrigger) return
  const linkTriggerLink =
    linkTrigger.parentNode.querySelector('.mm-listitem__text')
  if (!linkTriggerLink) return
  const realHrefValue = linkTriggerLink.getAttribute('href')

  const targetElement = document.querySelector(
    'div[data-mobile-menu-footer-level="n"] a'
  )
  if (!targetElement) return

  targetElement.setAttribute('href', realHrefValue)
}

function initLoadMore () {
  const loadMoreButtons = document.querySelectorAll('[data-load-more]')
  loadMoreButtons.forEach((button) => {
    button.addEventListener('click', function (event) {
      event.preventDefault()

      const loadLabel = this.innerHTML
      const loadLabelInData = this.getAttribute('data-load-label')

      this.innerHTML = loadLabelInData
      this.setAttribute('data-load-label', loadLabel)

      const tagID = this.getAttribute('data-load-more')

      const elementsToLoad = document.querySelectorAll(
        '*[data-load-more-tag="' + tagID + '"]'
      )

      elementsToLoad.forEach((element) => {
        const color = element.getAttribute('data-color')
        const src = element.getAttribute('data-src')
        const isLoaded = element.getAttribute('data-loaded')

        if (src) {
          if (String(isLoaded) === '1') {
            element.removeAttribute('data-loaded')
            element.parentNode.parentNode.classList.add('hidden')
          } else {
            element.src = src
            //element.onload = function () {
              element.parentNode.parentNode.classList.remove('hidden')
              element.setAttribute('data-loaded', 1)
            //}
          }
        }

        if (color) {
          if (String(isLoaded) === '1') {
            element.removeAttribute('data-loaded')
            element.parentNode.parentNode.classList.add('hidden')
          } else {
            element.parentNode.parentNode.classList.remove('hidden')
            element.setAttribute('data-loaded', 1)
          }
        }
      })
    })
  })

  const triggerButton = document.querySelector('[data-load-more]')
  if (!triggerButton) return

  const elementsToLoad = document.querySelectorAll('[data-src]')

  elementsToLoad.forEach((element) => {
    const image = new Image()
    image.src = element.getAttribute('[data-src]')
    image.onload = function () {
      image.parentNode.classList.toggle('hidden')
    }
  })
}

function closeAccordion (all = false) {
  const accordionIcons = document.querySelectorAll(
    '[data-accordion-trigger] svg [data-minus]'
  )
  const accordionSections = document.querySelectorAll(
    '[data-accordion-content]'
  )

  accordionIcons.forEach((icon) => {
    if (!all && !icon.classList.contains('hidden')) {
      return
    }
    icon.classList.remove('hidden')
  })
  accordionSections.forEach((section) => {
    if (!all && !section.classList.contains('hidden')) {
      return
    }
    section.classList.add('hidden')
  })
}

function initFinishes () {
  const finishHandlers = document.querySelectorAll('[data-modal-open]')
  const mobileTrigger = document.querySelectorAll(
    '[data-mobile-finishes-button]'
  )

  const mobileSection = document.querySelector(
    '[data-mobile-finishes-section]'
  )
  const mobileWrapper = document.querySelector(
    '[data-mobile-finishes-wrapper]'
  )

  mobileTrigger.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      if (window.innerWidth > 1023) return
      mobileSection.classList.toggle('hidden')
      mobileWrapper.classList.toggle('h-screen')
      mobileWrapper.classList.toggle('top-16')
    })
  })

  const modal = document.querySelector('[data-finish-modal]')
  if (!modal) return

  const titleTag = modal.querySelector('[data-finish-title]')
  const imageTag = modal.querySelector('[data-finish-image]')
  const colorimageTag = modal.querySelector('[data-finish-color]')

  finishHandlers.forEach((finish) => {
    finish.addEventListener('click', function () {
      const title = this.getAttribute('data-title')
      const image = this.getAttribute('data-image')
      const color = this.getAttribute('data-color')

      colorimageTag.classList.add('hidden')
      imageTag.classList.add('hidden')

      titleTag.innerHTML = title

      if (image) {
        imageTag.src = image
        imageTag.classList.remove('hidden')
        colorimageTag.classList.add('hidden')
      } else if (color) {
        imageTag.classList.add('hidden')
        colorimageTag.classList.remove('hidden')
        colorimageTag.style.backgroundColor = color
      }

      openModal()
    })
  })
}

function initFoldableSections () {
  const foldableWrappers = document.querySelectorAll('[data-foldable]')

  foldableWrappers.forEach(function (wrapper) {
    const trigger = wrapper.querySelector('[data-foldable-trigger]')
    const section = wrapper.querySelector('[data-foldable-section]')

    if (!trigger || !section) return

    trigger.addEventListener('click', function () {
      const altText = this.getAttribute('data-alt-label')
      const currentText = this.innerHTML

      this.innerHTML = altText
      this.setAttribute('data-alt-label', currentText)

      section.classList.toggle('hidden')
    })
  })
}

function initAccordion () {
  const accordionButtons = document.querySelectorAll(
    '[data-accordion-trigger]'
  )

  closeAccordion(true)

  let accordionSelected = null

  accordionButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const accordionID = this.getAttribute('data-accordion-trigger')
      const accordionSection = document.querySelector(
        '[data-accordion-content="' + accordionID + '"]'
      )
      closeAccordion(true)
      if (accordionID === accordionSelected) {
        accordionSection.classList.add('hidden')
        accordionSelected = null
      } else {
        accordionSection.classList.toggle('hidden')
        this.querySelector('svg [data-minus]').classList.toggle('hidden')
        accordionSelected = accordionID
      }
    })
  })
}

function initVideoGallery () {
  const menuItems = document.querySelectorAll('[data-chapter-button]')
  const currentChapter = document.querySelector('[data-chapter-current]')
  const chapters = document.querySelectorAll('[data-chapter]')
  menuItems.forEach((menuItem) => {
    menuItem.addEventListener('click', function () {
      const chapterID = menuItem.getAttribute('data-chapter-button')
      const chapterToLoad = document.querySelector(
        '[data-chapter="' + chapterID + '"]'
      )
      if (!chapterToLoad) return

      menuItems.forEach((c) => {
        c.classList.add('opacity-25')
        c.querySelector('span').classList.add('hidden')
      })
      chapters.forEach((c) => {
        c.classList.add('hidden')
        try {
          c.querySelector('video').pause()
        } catch (error) {
          console.error(error.message)
        }
      })

      this.querySelector('span').classList.remove('hidden')
      this.classList.remove('opacity-25')
      chapterToLoad.classList.remove('hidden')
    })
  })
}

const controls = '<div class="plyr__controls"></div>'

function initPlyr () {
  const player = Array.from(document.querySelectorAll('[data-video-plyr]')).map(
    (p) =>
      new Plyr(p, {
        playsinline: true
      })
  )
}

function setYearSlideshow () {
  const yearsSections = document.querySelectorAll('[data-year]')
  const currentSlide = document.querySelector(
    '[data-years] .slick-current [data-year-button]'
  )

  if (!currentSlide) return

  const yearSelected = currentSlide.getAttribute('data-year-button')

  yearsSections.forEach((y) => {
    const year = y.getAttribute('data-year')

    if (String(year) === String(yearSelected)) {
      y.classList.remove('opacity-0')
      y.classList.remove('overflow-hidden')
      y.classList.remove('h-0')
      y.classList.remove('invisible')
    } else {
      y.classList.add('opacity-0')
      y.classList.add('overflow-hidden')
      y.classList.add('h-0')
      y.classList.add('invisible')
    }
  })
}

function initYearsSlideshow () {
  $('[data-years]').on('afterChange', function (event, slick) {
    setYearSlideshow()
  })

  setYearSlideshow()
}

function initTabs () {
  const tabButtons = document.querySelectorAll('[data-tab-button]')
  const tabs = document.querySelectorAll('[data-tab]')
  tabButtons.forEach((tabButton) => {
    tabButton.addEventListener('click', function () {
      const targetElement = this.getAttribute('data-tab-button')

      // Close other tabs
      // And switch to the tab selected
      tabs.forEach((tab) => {
        const dataTab = tab.getAttribute('data-tab')
        if (dataTab !== targetElement) {
          tab.classList.add('h-0')
          tab.classList.add('opacity-0')
          tab.classList.add('invisible')
        } else {
          tab.classList.remove('h-0')
          tab.classList.remove('opacity-0')
          tab.classList.remove('invisible')
        }
      })

      // Toggle off the active status for the buttons
      tabButtons.forEach((tb) => {
        tb.classList.add('button--alt')
      })

      this.classList.remove('button--alt')
    })

    const isDefault = tabButton.getAttribute('data-tab-default')
    if (isDefault) {
      tabButton.click()
    }
  })
}

function openModal () {
  const modal = document.querySelector('[data-finish-modal]')
  if (!modal) return

  modal.classList.remove('hidden')
  document.body.classList.add('noscroll')
}

function closeModal () {
  const modal = document.querySelector('[data-finish-modal]')
  if (!modal) return

  modal.classList.add('hidden')
  document.body.classList.remove('noscroll')
}

function initFinishModal () {
  const modals = document.querySelectorAll('[data-finish-modal]')
  modals.forEach((modal) => {
    const closeButton = modal.querySelector('[data-finish-close-button]')

    closeButton.addEventListener('click', function () {
      closeModal()
    })
  })
}

function initSidebox () {
  const sideboxButtons = document.querySelectorAll('[data-sidebox-button]')

  sideboxButtons.forEach((sidebox) => {
    sidebox.addEventListener('click', function () {
      const parent = this.parentNode
      const section = parent.querySelector('[data-sidebox-container]')

      section.classList.toggle('hidden')
    })
  })
}

function initForm () {
  const forms = document.querySelectorAll('[data-form]')

  forms.forEach((form) => {
    form.addEventListener('submit', function (event) {
      event.preventDefault()

      const form = this
      form.classList.add('opacity-25')
      form.classList.add('pointer-events-none')

      const method = form.getAttribute('method')
      const language = form.getAttribute('data-language')
      const successMessage = form.getAttribute('data-success-message')
      const errorMessageGeneric = form.getAttribute(
        'data-error-message-generic'
      )
      const errorMessagePrivacy = form.getAttribute(
        'data-error-message-privacy'
      )
      const targetMessage = form.getAttribute('data-target-message')

      const targetMessageDOM = form.querySelector(targetMessage)

      const recaptcha = document.getElementsByClassName('g-recaptcha-response')

      const data = {
        // eslint-disable-next-line no-undef
        _nonce: grootAjax.nonce,
        action: 'newsletter',
        language: language,
        first_name: document.getElementById('first_name').value,
        last_name: document.getElementById('last_name').value,
        job: document.getElementById('job').value,
        country: document.getElementById('country').value,
        city: document.getElementById('city').value,
        email: document.getElementById('email').value
      }
      if (recaptcha) {
        data.recaptcha = recaptcha[0].value
      }

      let privacy = document.getElementsByName('privacy')
      for (let i = 0, length = privacy.length; i < length; i++) {
        if (privacy[i].checked) {
          privacy = privacy[i].value
          break
        }
      }

      try {
        if (privacy !== '1') {
          throw new Error(errorMessagePrivacy)
        }

        // eslint-disable-next-line no-undef
        $.ajax(grootAjax.url, {
          method: method,
          data: data
        })
          .success(function (response) {
            if (response.success === false) {
              targetMessageDOM.innerHTML = response.data
            } else {
              targetMessageDOM.innerHTML = successMessage
            }
          })
          .error(function (response) {
            targetMessageDOM.innerHTML = errorMessageGeneric
          })
          .complete(function () {
            form.classList.remove('opacity-25')
            form.classList.remove('pointer-events-none')
          })
      } catch (error) {
        targetMessageDOM.innerHTML = error.message
        form.classList.remove('opacity-25')
        form.classList.remove('pointer-events-none')
      }
    })
  })
}

function initAOS () {
  AOS.init({
    // Global settings:
    disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 200, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 1200, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom' // defines which position of the element regarding to window should trigger the animation
  })
}

function setDotsPosition (parentClass = '') {
  const galleries = document.querySelectorAll(parentClass)

  galleries.forEach((gallery) => {
    const currentSlide = gallery.querySelector('.slick-current')
    if (currentSlide) {
      const image = currentSlide.querySelector('img')
      if (image) {
        const size = image.getBoundingClientRect()
        const { height } = size

        const dots = gallery.querySelector('[data-dots]')
        if (dots) {
          dots.style.position = 'absolute'
          dots.style.top = height - 30 + 'px'
          dots.style.right = '0px'

          const dotsList = gallery.querySelector('[data-dots] ul')
          if (dotsList) {
            dotsList.style.top = '0px'
          }
        }
      }
    }
  })
}
